const cumulativeOffset = (element) => {
  let top = 0;
  let left = 0;
  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent; /* eslint-disable-line no-param-reassign */
  } while (element);

  return {
    top,
    left,
  };
};

const delegate = (root, eventName, selector, handler) => {
  if (!root) {
    return;
  }
  root.addEventListener(eventName, (event) => {
    // root is sometimes document, whose event.target is not guaranteed to expose closest().
    const { target } = event;
    const match = target && typeof target.closest === 'function'
      ? target.closest(selector)
      : null;
    if (match) {
      handler(match, event);
    }
  });
};

const isElementContained = (element, ancestorSelector) => {
  const ancestor = document.querySelector(ancestorSelector);
  if (!ancestor) {
    return false;
  }
  return ancestor.contains(element);
};

const getElementLink = (element) => {
  const isLink = element.nodeName === 'A';
  if (isLink) {
    return element;
  }
  const wrapper = element.closest('a');
  return wrapper;
};

const getScriptData = (attributeName) => {
  const script = document.currentScript || [...document.getElementsByTagName('script')].pop();
  return script.dataset[attributeName] || null;
};

export {
  cumulativeOffset,
  delegate,
  getElementLink,
  getScriptData,
  isElementContained,
};
